
import * as $ from "jquery";
import ViewBox from 'vux/src/components/view-box/index.vue'


export default {
name: "App",
components: {
ViewBox
},
data() {
return {
showFoot: true,
isNviewBox: true,
getTime: "",
residenceTime: 0,
startTime: "",
pageUrl: "",
isinsertPageStatistics: true,
namepo: "1",
noKey: true,
salesmanCode:'',
};
},
methods: {
RondomPass() {
return Math.random()
.toString(36)
.substr(-10);
},

judgeFn(time, time1) {
return new Date(time).toDateString() === new Date(time1).toDateString();
},
upDatatimeDate(timestamp, timestampData) {



localStorage.setItem("timestamp", timestamp);
localStorage.setItem("timestampData", timestampData);
console.log("timestampData", timestampData);
this.setCookie("UM_distinctid", timestampData);
console.log("UM_distinctid -C", this.getCookie("UM_distinctid"));
},
setUm() {
var timestamp1 = parseInt(localStorage.getItem("timestamp")); 
var timestamp1Data = localStorage.getItem("timestampData"); 

var timestamp2 = new Date().getTime();
var timestamp2Data = this.RondomPass();

if (timestamp1 != "") {
if (this.judgeFn(timestamp1, timestamp2)) {

this.upDatatimeDate(timestamp1, timestamp1Data);
} else {

this.upDatatimeDate(timestamp2, timestamp2Data);
}
} else {
this.upDatatimeDate(timestamp2, timestamp2Data);
}
},

getCookie(name) {
var arr,
reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
else return null;
},
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/"; 
console.log(d);
},
getBrowser() {
var is360 = false;
var isIE = false;
var isFirefox = false;
var isChrome = false;
var isEdge = false;
var broName = "Runing";
var str = "";
var strStart = 0;
var strStop = 0;
var arr = new Array();
var temp = "";

var userAgent = window.navigator.userAgent; 

/*alert(userAgent);*/


if (userAgent.indexOf("Firefox") != -1) {
isFireFox = true;
/*broName = 'FireFox浏览器';*/
strStart = userAgent.indexOf("Firefox");
temp = userAgent.substring(strStart);
broName = temp.replace("/", "版本号");
}


if (userAgent.indexOf("Edge") != -1) {
isEdge = true;
/*broName = 'Edge浏览器';*/
strStart = userAgent.indexOf("Edge");
temp = userAgent.substring(strStart);
broName = temp.replace("/", "版本号");
}


if (userAgent.indexOf("NET") != -1 && userAgent.indexOf("rv") != -1) {
isIE = true;
/*broName = 'IE浏览器'; */
strStart = userAgent.indexOf("rv");
strStop = userAgent.indexOf(")");
temp = userAgent.substring(strStart, strStop);
broName = temp.replace("rv", "IE").replace(":", "版本号");
}


if (
userAgent.indexOf("WOW") != -1 &&
userAgent.indexOf("NET") < 0 &&
userAgent.indexOf("Firefox") < 0
) {
if (navigator.javaEnabled()) {
is360 = true;
broName = "360安全浏览器-极速模式";
} else {
is360 = true;
broName = "360极速浏览器-极速模式";
}
}


if (
userAgent.indexOf("WOW") != -1 &&
userAgent.indexOf("NET") != -1 &&
userAgent.indexOf("MSIE") != -1 &&
userAgent.indexOf("rv") < 0
) {
is360 = true;
broName = "360兼容模式";
}


if (userAgent.indexOf("WOW") < 0 && userAgent.indexOf("Edge") < 0) {
isChrome = true;
/*broName = 'Chrome浏览器';*/
strStart = userAgent.indexOf("Chrome");
strStop = userAgent.indexOf(" Safari");
temp = userAgent.substring(strStart, strStop);
broName = temp.replace("/", "版本号");
}

return broName;
},

getStatistics1(pageName, pageUrl, moduleName) {
var that = this;

var equipment = "手机";


var startTime = Date.parse(new Date());


var strUrl = window.location.href;






var ip = "";
var adddress = "";
var province = "";
var city = "";
var loadScript;



























var urlData = window.location.href.split("/")[2];

console.log("urlData", urlData);



that.$request
.post("/pageStatistics/insertPageStatistics", {
pageName,
pageUrl,
moduleName,
residenceTime: that.residenceTime,
browser: that.getBrowser(),
equipment: equipment,



module: that.$route.meta.moduleName.split("-")[0],
domain: urlData,
umDistinctId: that.getCookie("UM_distinctid")
})
.then(data => {
if (data.code == 0) {
that.pageUrl = location.href.split("?")[0];
} else {




}

});

},

/***************************** */
randomString(len) {
len = len || 32;
var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
var maxPos = chars.length;
var pwd = "";
for (let i = 0; i < len; i++) {
pwd += chars.charAt(Math.floor(Math.random() * maxPos));
}
return pwd;
},

timeDate() {
var timestamp1 = parseInt(localStorage.getItem("timestamp")); 
console.log("timestamp1", localStorage.getItem("timestamp"));
var timestamp2 = new Date().getTime(); 
var timestamp1Data = localStorage.getItem("timestampData"); 
var timestamp2Data = this.randomString(10); 
if (timestamp1 != "") {
console.log("不为空");
if (this.judgeFn(timestamp1, timestamp2)) {
console.log("同");
this.upDatatimeDate(timestamp1, timestamp1Data); 
} else {
console.log("不同");
this.upDatatimeDate(timestamp2, timestamp2Data); 
}
} else {
console.log("空");
this.upDatatimeDate(timestamp2, timestamp2Data); 
}
},

getStatistics() {
var that = this;
var endTime = Date.parse(new Date());
var pastObj = JSON.parse(localStorage.getItem("pastObj"));
var pagename1 = pastObj.url.split("?")[0].split("/");

if (!pastObj.name) {
pastObj.name = "首页-3d产品打印加工_手板模型打印_3D人物建模-深圳齐思印";
localStorage.setItem("pastObj", JSON.stringify(pastObj));
}


let strUrl = window.location.href;
let ip = "";
let adddress = "";
let province = "";
var city = "";
let loadScript;

if (!that.getCookie("UM_distinctid")) {
this.timeDate();
}

var pam = {
token: that.getCookie("token"),
pageName: pagename1[pagename1.length - 1].split(".")[0]
? pagename1[pagename1.length - 1].split(".")[0]
: "/",
pageUrl: pastObj.url.split("?")[0], //当前页面
module: pastObj.name.split("-")[0], //
moduleName: pastObj.name,
residenceTime: endTime - pastObj.startTime, //访问时间
equipment: "手机", //设备
referer: pastObj.url2, //跳转前的页面
domain: window.location.href.split("/")[2], //网站
umDistinctId: that.getCookie("UM_distinctid"),
browser: that.getBrowser() 
};

console.log("that.isinsertPageStatistics", that.isinsertPageStatistics);
if (endTime - pastObj.startTime > 1000 && that.isinsertPageStatistics) {


that.$request
.post("/pageStatistics/insertPageStatistics", pam)
.then(data => {
that.isinsertPageStatistics = false;

if (data.code == 0) {
if (that.namepo == "1") {
var pastObj = {
url: window.location.href,
url2: JSON.parse(localStorage.getItem("pastObj")).url,
name: that.$router.history.current.meta.content
? that.$router.history.current.meta.content.name2
: "首页-3d产品打印加工_手板模型打印_3D人物建模-深圳齐思印",
startTime: endTime
};

localStorage.setItem("pastObj", JSON.stringify(pastObj));
that.timeDate();
} else {
localStorage.removeItem("pastObj");
}
} else {
localStorage.removeItem("pastObj");
}
that.isinsertPageStatistics = true;
});
}


},

getFocus() {
let that = this;
var clientHeight = document.body.clientHeight;
var _focusElem = null; 

document.body.addEventListener(
"focus",
function(e) {
_focusElem = e.target || e.srcElement;
},
true
);

window.addEventListener("resize", function() {
if (document.querySelector(".noKey_flex")) {
document.querySelector(".noKey_flex").style.display = "flex";
}

that.noKey = true;

if (_focusElem && document.body.clientHeight < clientHeight) {

if (document.querySelector(".noKey_flex")) {
document.querySelector(".noKey_flex").style.display = "none";
}
that.noKey = false;
_focusElem.scrollIntoView(false);
}
});
},
onbeforeunloadFun() {
this.namepo = "1";
console.log("onbeforeunloadFun", this.namepo);

this.getStatistics();
},

beforeunloadHandler(e) {
this.namepo = "关闭";
console.log("beforeunloadHandler");
this.getStatistics();
},
},

watch: {
$route(to, from) {
this.startTime = Date.parse(new Date());

if (from.name == "shoppingCart" || from.name == "submitOrder") {
to.meta.keepAlive = false;
}

this.getTime = Date.parse(new Date());
if (
from.name == "shop" ||
from.name == "myOrder" ||
from.name == "print"
) {
from.meta.keepAlive = true;
}

to.meta.showFoot ? (this.showFoot = true) : (this.showFoot = false);

to.meta.isNviewBox ? (this.isNviewBox = true) : (this.isNviewBox = false);
this.$nextTick(() => {
var obj = document.getElementById("vux_view_box_body");
if (!!obj) {
obj.children[0].style.paddingTop = "45px";
}

});

this.namepo = "1";
if (
localStorage.getItem("pastObj") &&
localStorage.getItem("pastObj") != ""
) {
console.log("xxxxxxxxxxxxxx");
this.getStatistics();
} else {
console.log("xxxxxxxxxxxxxx2");
var pastObj = {
url: window.location.href, //当前的
url2: window.location.href, //当前的
name: this.$router.history.current.meta.content
? this.$router.history.current.meta.content.name2
: "首页-3d产品打印加工_手板模型打印_3D人物建模-深圳齐思印",
startTime: Date.parse(new Date())
};

localStorage.setItem("pastObj", JSON.stringify(pastObj));
}

this.getFocus();
},
getTime(val, oldVal) {
this.residenceTime = val - oldVal;

if (location.hash == "#/loginTransfers") {
if (this.$route.query.token) {
this.setCookie("_token", this.$route.query.token, 0.288);
}
}
}
},

created() {



this.salesmanCode=   this.$router.history.current.query.salesmanCode;  
console.log('this.salesmanCode',this.salesmanCode);

if(this.salesmanCode){
sessionStorage.setItem('salesmanCode',this.salesmanCode)
console.log('this.salesmanCode--*---', sessionStorage.getItem('salesmanCode'));

}


window.addEventListener("visibilitychange", this.onbeforeunloadFun, false); 
window.addEventListener(
"beforeunload",
e => this.beforeunloadHandler(e),
false
); //关闭  浏览器
},
mounted() {
this.setUm();
this.getTime = Date.parse(new Date());
this.pageUrl = location.href;


this.$route.meta.showFoot
? (this.showFoot = true)
: (this.showFoot = false);

this.$route.meta.isNviewBox
? (this.isNviewBox = true)
: (this.isNviewBox = false);

if (this.$route.meta.requireLogin && !this.$token) {
this.$router.push({
path: "/login",
query: {
fullPath: this.$route.fullPath
}
});
}
this.$nextTick(() => {
var obj = document.getElementById("vux_view_box_body");
if (!!obj && obj.children.length != 0) {
obj.children[0].style.paddingTop = "45px";
}
});
this.getFocus();
},

destroyed() {
window.removeEventListener("visibilitychange", this.onbeforeunloadFun); 
window.removeEventListener("beforeunload", e =>
this.beforeunloadHandler(e)
);
}
};



// WEBPACK FOOTER //
// ./src/App.vue